import { render, staticRenderFns } from "./HeadmasterTrigger.vue?vue&type=template&id=a5249c3c"
import script from "./HeadmasterTrigger.vue?vue&type=script&lang=js"
export * from "./HeadmasterTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports